var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "mb5" },
        [
          _c(
            "div",
            { staticClass: "tip01" },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("placeOrder.automaticPrinting1")) + " "
              ),
              _c(
                "el-link",
                {
                  staticStyle: { "font-size": "16px" },
                  attrs: {
                    href: _vm.$store.getters.expressWmsPluginLink,
                    type: "warning",
                  },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("placeOrder.automaticPrinting2")) + " "
                  ),
                ]
              ),
              _vm._v(
                " " + _vm._s(_vm.$t("placeOrder.automaticPrinting3")) + " "
              ),
            ],
            1
          ),
          _c(
            "el-form",
            {
              ref: "ruleFormRef",
              attrs: {
                inline: false,
                model: _vm.queryForm,
                "label-position": "top",
                size: "large",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "waybillBagNumber" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: {
                        width: "150px",
                        "margin-top": "10px",
                        "margin-right": "5px",
                      },
                      on: { change: _vm.changeNum },
                      model: {
                        value: _vm.selectNum,
                        callback: function ($$v) {
                          _vm.selectNum = $$v
                        },
                        expression: "selectNum",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("GlobalSetObj.scannerNumber"),
                          value: 1,
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("newOrder.InvoiceKey"),
                          value: 2,
                        },
                      }),
                    ],
                    1
                  ),
                  _c("el-input", {
                    ref: "inputRef",
                    staticStyle: { width: "350px" },
                    attrs: {
                      placeholder:
                        _vm.selectNum === 1
                          ? _vm.$t("GlobalSetObj.scannerNumber")
                          : _vm.$t("newOrder.InvoiceKey"),
                      clearable: "",
                    },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.arrivedOut($event)
                      },
                    },
                    model: {
                      value: _vm.currentInputValue,
                      callback: function ($$v) {
                        _vm.currentInputValue =
                          typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "currentInputValue",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("el-divider", {
            staticStyle: { height: "2px", margin: "22px 0" },
          }),
          _c(
            "el-form",
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "150px" },
                              attrs: { size: "small" },
                              model: {
                                value: _vm.selectTime,
                                callback: function ($$v) {
                                  _vm.selectTime = $$v
                                },
                                expression: "selectTime",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t(
                                    "orderCenterCont.anjunWaybillNumber"
                                  ),
                                  value: 1,
                                },
                              }),
                            ],
                            1
                          ),
                          _c("el-input", {
                            staticClass: "textClass",
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t("newOrder.PreciseSearch1"),
                              rows: 1,
                              type: "textarea",
                            },
                            on: { blur: _vm.BlockNewline },
                            nativeOn: {
                              keydown: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.BlockNewline($event)
                              },
                            },
                            model: {
                              value: _vm.queryForm.waybillNumbers,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm, "waybillNumbers", $$v)
                              },
                              expression: "queryForm.waybillNumbers",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.printTime"),
                          },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              clearable: false,
                              "default-time": ["00:00:00", "23:59:59"],
                              "end-placeholder": _vm.$t(
                                "collectionCenter.EndTime"
                              ),
                              "picker-options": _vm.pickerOptions,
                              "start-placeholder": _vm.$t(
                                "collectionCenter.StartTime"
                              ),
                              "range-separator": "—",
                              size: "small",
                              type: "datetimerange",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                            },
                            on: { change: _vm.timeChange },
                            model: {
                              value: _vm.timeValue,
                              callback: function ($$v) {
                                _vm.timeValue = $$v
                              },
                              expression: "timeValue",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.CustomerName"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "spareNumberPoo.Only10AreDisplayed"
                                ),
                                "remote-method": _vm.getCustomerPage,
                                clearable: "",
                                filterable: "",
                                multiple: "",
                                remote: "",
                                "reserve-keyword": "",
                                size: "small",
                              },
                              on: { clear: _vm.getCustomerPage },
                              model: {
                                value: _vm.queryForm.customerIds,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm, "customerIds", $$v)
                                },
                                expression: "queryForm.customerIds",
                              },
                            },
                            _vm._l(_vm.customerList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label:
                                    item.customerAlias +
                                    "(" +
                                    item.username +
                                    ")",
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.OperationSite"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.Only10AreDisplayed"
                                ),
                                "remote-method": _vm.remoteGetSiteList,
                                clearable: "",
                                filterable: "",
                                multiple: "",
                                remote: "",
                                "reserve-keyword": "",
                                size: "small",
                              },
                              on: { clear: _vm.remoteGetSiteList },
                              model: {
                                value: _vm.queryForm.printableSiteIds,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm,
                                    "printableSiteIds",
                                    $$v
                                  )
                                },
                                expression: "queryForm.printableSiteIds",
                              },
                            },
                            _vm._l(_vm.siteList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("collectionCenter.operator") },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.Only10AreDisplayed"
                                ),
                                "remote-method": _vm.getOperator,
                                clearable: "",
                                filterable: "",
                                multiple: "",
                                remote: "",
                                "reserve-keyword": "",
                                size: "small",
                              },
                              on: { clear: _vm.getOperator },
                              model: {
                                value: _vm.queryForm.printableUserIds,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm,
                                    "printableUserIds",
                                    $$v
                                  )
                                },
                                expression: "queryForm.printableUserIds",
                              },
                            },
                            _vm._l(_vm.operatorList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label:
                                    item.realName + "（" + item.username + "）",
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { "margin-bottom": "20px" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.getSearch },
                    },
                    [_vm._v(_vm._s(_vm.$t("newOrder.search")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "info" },
                      on: { click: _vm.reset },
                    },
                    [_vm._v(_vm._s(_vm.$t("newOrder.reset")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "success" },
                      on: { click: _vm.downloadAll },
                    },
                    [_vm._v(_vm._s(_vm.$t("collectionCenter.allExport")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "header-cell-style": { background: "#f2f2f2", color: "black" },
                border: "",
                height: "600",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("GlobalSetObj.serial"),
                  align: "center",
                  type: "index",
                  width: "100",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.scanInfo"),
                  align: "center",
                  "min-width": "180",
                  prop: "scanInformation",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("orderCenterCont.anjunWaybillNumber"),
                  align: "center",
                  "min-width": "160",
                  prop: "waybillNumber",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(_vm._s(scope.row.waybillNumber || "--")),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.CustomerName"),
                  align: "center",
                  "min-width": "180",
                  prop: "customerName",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.printTime"),
                  align: "center",
                  "min-width": "180",
                  prop: "printableTime",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.operator"),
                  align: "center",
                  "min-width": "150",
                  prop: "printableUserName",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.OperationSite"),
                  align: "center",
                  "min-width": "150",
                  prop: "printableSite",
                },
              }),
            ],
            1
          ),
          _c("el-pagination", {
            staticStyle: { margin: "10px 0", float: "right" },
            attrs: {
              "current-page": _vm.queryForm.pageNumber,
              "page-size": _vm.queryForm.pageSize,
              "page-sizes": [50, 100, 200, 400],
              total: _vm.queryForm.total,
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
          _c(
            "div",
            { staticStyle: { display: "none" } },
            [_c("pdf", { ref: "pdfPrint", attrs: { src: _vm.viewUrl } })],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false",
            },
          ],
        },
        [
          _c("audio", {
            ref: "errRef",
            attrs: { src: _vm.errorMp3, controls: "controls" },
          }),
          _c("audio", {
            ref: "okRef",
            attrs: { src: _vm.okMp3, controls: "controls" },
          }),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.handleClose,
            title: _vm.$t("GlobalSetObj.tips"),
            visible: _vm.printTipsVisible,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.printTipsVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "printTips_class" },
            [
              _c("div", { staticClass: "printTips_title" }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("collectionCenter.selectWaybill")) + " "
                ),
              ]),
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.checkList,
                    callback: function ($$v) {
                      _vm.checkList = $$v
                    },
                    expression: "checkList",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v(
                      _vm._s(_vm.$t("collectionCenter.originalWaybill")) +
                        "：" +
                        _vm._s(_vm.printTips.forwardWaybillNumber) +
                        " "
                    ),
                  ]),
                  _c("el-radio", { attrs: { label: 2 } }, [
                    _vm._v(
                      _vm._s(_vm.$t("collectionCenter.returnNoteNum")) +
                        "：" +
                        _vm._s(_vm.printTips.waybillNumber)
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.handleClose } },
                [_vm._v(_vm._s(_vm.$t("roleManage.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.submitPr },
                },
                [_vm._v(_vm._s(_vm.$t("roleManage.confirm")) + " ")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("printTipsCom", {
        ref: "printTipsComRef",
        on: { autoPrint: _vm.submitPr },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }